import { render } from "./ModalCancelOrDelete.vue?vue&type=template&id=04f4df26"
import script from "./ModalCancelOrDelete.vue?vue&type=script&lang=js"
export * from "./ModalCancelOrDelete.vue?vue&type=script&lang=js"

import "./ModalCancelOrDelete.vue?vue&type=style&index=0&id=04f4df26&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__